import { CategoryPageSectionType } from '../../types/TemplateConfiguration'
import {
  BUSINESS_CARDS_INCREMENT_EXPERIMENT_NAME,
  BUSINESS_CARDS_INCREMENT_EXPERIMENT_VARIATION_1,
  BUSINESS_CARDS_INCREMENT_EXPERIMENT_VARIATION_2,
} from '../../constants/businessCardIncrementExperiment'
import StockOptions from '../../components/StockOptions/StockOptions'
import DesignTemplate from '../../components/DesignTemplate'

enum RegisteredTests {
  BUSINESS_CARDS_INCREMENT = BUSINESS_CARDS_INCREMENT_EXPERIMENT_NAME,
}

type TestRegistry = {
  [testKey in RegisteredTests | string]: {
    [variationKey: string]: {
      sectionType?: CategoryPageSectionType
      position?: number
      component: (props: any) => JSX.Element | null
      mcIds?: string[]
      locales?: string[]
      isPageSection?: boolean
      sectionIdsToRemove?: Record<string, string[]>
    }[]
  }
}

const testRegistry: TestRegistry = {
  [RegisteredTests.BUSINESS_CARDS_INCREMENT]: {
    [BUSINESS_CARDS_INCREMENT_EXPERIMENT_VARIATION_1]: [
      {
        sectionType: 'stock options',
        position: 4,
        component: StockOptions,
        mcIds: ['businessCards'],
        locales: ['en-GB'],
        sectionIdsToRemove: {
          'en-GB': ['be95c5ec-4980-44b9-83e8-9a09df878425', '5e701269-57a1-4301-ae1f-59706bcb1996', '98bbf4a3-d655-43b1-9c1d-f1fc72181389'],
        },
      },
      {
        sectionType: 'design template',
        position: 4,
        component: DesignTemplate,
        mcIds: ['businessCards'],
        locales: ['en-US', 'es-US'],
        sectionIdsToRemove: {
          'en-US': ['6f7d0329-b4a9-4cc6-9cff-90618e84980a'],
        },
      },
      {
        sectionType: 'design template',
        position: 5,
        component: DesignTemplate,
        mcIds: ['businessCards'],
        locales: ['en-GB'],
        sectionIdsToRemove: {
          'en-GB': ['c3dee446-9db7-403f-961d-45d507adaeb4'],
        },
      },
    ],
    [BUSINESS_CARDS_INCREMENT_EXPERIMENT_VARIATION_2]: [
      {
        sectionType: 'stock options',
        position: 4,
        component: StockOptions,
        mcIds: ['businessCards'],
        locales: ['en-GB'],
        sectionIdsToRemove: {
          'en-GB': ['be95c5ec-4980-44b9-83e8-9a09df878425', '5e701269-57a1-4301-ae1f-59706bcb1996', '98bbf4a3-d655-43b1-9c1d-f1fc72181389'],
        },
      },
      {
        sectionType: 'design template',
        position: 3,
        component: DesignTemplate,
        mcIds: ['businessCards'],
        locales: ['en-US', 'es-US'],
        sectionIdsToRemove: {
          'en-US': ['6f7d0329-b4a9-4cc6-9cff-90618e84980a'],
        },
      },
      {
        sectionType: 'design template',
        position: 3,
        component: DesignTemplate,
        mcIds: ['businessCards'],
        locales: ['en-GB'],
        sectionIdsToRemove: {
          'en-GB': ['c3dee446-9db7-403f-961d-45d507adaeb4'],
        },
      },
    ],
  },
}

const getRegisteredTest = (
  experimentKey: string,
  variationKey: string,
  metadata?: {
    newSectionPosition: number | undefined
  },
) => {
  if ((Object.values(RegisteredTests) as string[]).includes(experimentKey)) {
    const testVariations = testRegistry[experimentKey][variationKey]
    if (testVariations) {
      return testVariations.map((variation) => ({
        ...variation,
        position: metadata?.newSectionPosition ?? variation.position,
      }))
    }
  }
}

const getSupportedLocales = (experimentKey: string, variationKey: string) => {
  if ((Object.values(RegisteredTests) as string[]).includes(experimentKey)) {
    return testRegistry[experimentKey][variationKey][0].locales?.map((locale) => locale.toLowerCase())
  }
}

const getSupportedMechandisingId = (experimentKey: string, variationKey: string) => {
  if ((Object.values(RegisteredTests) as string[]).includes(experimentKey)) {
    return testRegistry[experimentKey][variationKey][0].mcIds
  }
}

export { RegisteredTests, getRegisteredTest, getSupportedLocales, getSupportedMechandisingId }
